import { createContext, useContext, useMemo, useState, type ReactNode } from 'react'

/**
 * La periode est un etat de l application, pas un filtre recopie dans chaque
 * ecran. Deux ecrans ne peuvent pas montrer deux periodes differentes.
 */
interface Periode { debut: string; fin: string; libelle: string }
interface Ctx { periode: Periode; setPeriode: (p: Periode) => void }

const PeriodeCtx = createContext<Ctx | null>(null)

function quinzaineCourante(): Periode {
  const d = new Date()
  const y = d.getUTCFullYear(), m = d.getUTCMonth() + 1, jour = d.getUTCDate()
  const dernier = new Date(Date.UTC(y, m, 0)).getUTCDate()
  const p = (n: number) => String(n).padStart(2, '0')
  return jour <= 15
    ? { debut: `${y}-${p(m)}-01`, fin: `${y}-${p(m)}-15`, libelle: `1 au 15 ${p(m)}/${y}` }
    : { debut: `${y}-${p(m)}-16`, fin: `${y}-${p(m)}-${p(dernier)}`, libelle: `16 au ${dernier} ${p(m)}/${y}` }
}

export function FournisseurPeriode({ children }: { children: ReactNode }) {
  const [periode, setPeriode] = useState<Periode>(quinzaineCourante)
  const valeur = useMemo(() => ({ periode, setPeriode }), [periode])
  return <PeriodeCtx.Provider value={valeur}>{children}</PeriodeCtx.Provider>
}

export function usePeriode(): Ctx {
  const c = useContext(PeriodeCtx)
  if (!c) throw new Error('usePeriode hors du fournisseur')
  return c
}
